

/// <reference path="Tag.ts" />

// Generated class SupportTag_ManagedObject

class SupportTag_ManagedObject extends Tag
{

    // Property: color
    set color(value:string) {
        this.setValueForKey(value, 'color');
    }
    get color():string {
        return this.valueForKey('color');
    }
    set colorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'color');
    }
    get colorPrimitiveValue():string {
        return this.primitiveValueForKey('color');
    }

    // Relationship: tickets
    protected _tickets:MIOManagedObjectSet = null;
    get tickets():MIOManagedObjectSet {
        return this.valueForKey('tickets');
    }
    addTicketsObject(value:SupportTicket) {
        this._addObjectForKey(value, 'tickets');
    }
    removeTicketsObject(value:SupportTicket) {
        this._removeObjectForKey(value, 'tickets');
    }
}
